<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="$router.back()" />
      </template>
      電話番号の変更
    </Header>
    <div class="my-5 mx-4">
      <PhoneNumberInputGroup
        :value="oldPhoneNumber"
        label="現在の電話番号"
        placeholder="の携帯電話番号"
        class="mb-3"
        disabled
        data-testid="oldPhoneNumber"
      />
      <CustomValidationObserver
        v-slot="{ handleSubmit }"
        tag="div"
        class="w-100"
      >
        <BForm @submit.stop.prevent="handleSubmit(nextStep)">
          <ValidationField
            v-slot="validationState"
            label="電話番号"
            rules="required|numeric|length:11|phonenumber_to_receive_sms"
            name="newPhoneNumber"
          >
            <PhoneNumberInputGroup
              v-model="newPhoneNumber"
              label="変更後の電話番号"
              placeholder="変更後の電話番号"
              class="mb-3"
              :validation-state="validationState"
              data-testid="newPhoneNumber"
            />
          </ValidationField>

          <AppButton
            block
            @click="handleSubmit(nextStep)"
            data-testid="submitButton"
          >
            次へ
          </AppButton>
        </BForm>
      </CustomValidationObserver>
    </div>
  </div>
</template>

<script lang="ts">
import Header from "@/components/organisms/common/Header.vue";
import { Component, Vue } from "vue-facing-decorator";
import PhoneNumberInputGroup from "@/components/molecules/form/PhoneNumberInputGroup.vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { authStore } from "@/store/auth";
import { showErrorModal, ErrorType } from "@/utils/showErrorModal";
import { accountService } from "@/app/services/AccountService";
import { authService } from "@/app/services/AuthService";

@Component({
  components: {
    AppButton,
    FeatherIcon,
    Header,
    PhoneNumberInputGroup
  }
})
export default class EditPhoneNumber extends Vue {
  oldPhoneNumber = "";
  newPhoneNumber = "";

  async created() {
    try {
      this.$loading.show();
      const res = await accountService.fetchPhoneNumber();
      this.oldPhoneNumber = res.phoneNumber;
    } catch (error) {
      await showErrorModal(this, error as ErrorType);
    } finally {
      this.$loading.hide();
    }
  }

  async nextStep() {
    try {
      this.$loading.show();
      if (await this.isRegisteredPhoneNumber()) {
        await this.$bvModal.msgBoxOk("登録済みの電話番号です", {
          centered: true
        });
      } else {
        await authStore.changePhoneNumber(this.newPhoneNumber);
        await this.$router.push({ name: "EditPhoneNumberAuth" });
      }
    } catch {
      await this.$bvModal.msgBoxOk("不正な操作です", {
        centered: true
      });
    } finally {
      this.$loading.hide();
    }
  }

  async isRegisteredPhoneNumber() {
    const body = {
      phoneNumber: this.newPhoneNumber
    };
    const res = await authService.requestWorkerLoginStatus(body);
    return res.status !== "new_user";
  }
}
</script>

<style scoped></style>
